const values = [
  {
    icon: 'ri-heart-pulse-line',
    color: '#ff2d78',
    title: 'Здоровье прежде всего',
    text: 'Каждое решение мы принимаем с мыслью о здоровье наших клиентов. Никаких компромиссов с качеством.',
  },
  {
    icon: 'ri-shield-check-line',
    color: '#00f5ff',
    title: 'Гарантия подлинности',
    text: 'Все препараты закупаются напрямую у производителей и официальных дистрибьюторов. Полная прослеживаемость через систему МДЛП.',
  },
  {
    icon: 'ri-time-line',
    color: '#39ff14',
    title: 'Доступность 24/7',
    text: 'Работаем круглосуточно — онлайн и в аптеках. Экспресс-доставка за 15 минут в Москве и Санкт-Петербурге.',
  },
  {
    icon: 'ri-price-tag-3-line',
    color: '#f0ff00',
    title: 'Честные цены',
    text: 'Мониторинг цен конкурентов в режиме реального времени. Гарантируем лучшую цену или вернём разницу.',
  },
];

const AboutValues = () => (
  <section className="px-6 lg:px-12 pb-24">
    <div className="max-w-7xl mx-auto">
      <div className="mb-14">
        <p className="font-mono text-xs tracking-[0.3em] text-neon-cyan/60 mb-2">НАШИ ПРИНЦИПЫ</p>
        <h2 className="font-orbitron font-black text-3xl md:text-4xl text-white">
          ЦЕННОСТИ<br />
          <span style={{ color: '#f0ff00', textShadow: '0 0 20px #f0ff0060' }}>КОМПАНИИ</span>
        </h2>
        <div className="mt-3 w-16 h-0.5" style={{ background: 'linear-gradient(90deg, #f0ff00, transparent)' }} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {values.map((v) => (
          <div
            key={v.title}
            className="card-cyber rounded-2xl p-7 flex gap-5 group transition-all duration-300 relative overflow-hidden"
            style={{ borderColor: `${v.color}20` }}
          >
            <div
              className="w-12 h-12 flex items-center justify-center rounded-xl shrink-0"
              style={{ background: `${v.color}15`, border: `1px solid ${v.color}40` }}
            >
              <i className={`${v.icon} text-2xl`} style={{ color: v.color }} />
            </div>
            <div>
              <h3 className="font-orbitron font-bold text-sm text-white mb-2">{v.title}</h3>
              <p className="font-mono text-xs text-white/40 leading-relaxed">{v.text}</p>
            </div>
            <div
              className="absolute bottom-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
              style={{ background: `linear-gradient(90deg, transparent, ${v.color}, transparent)` }}
            />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default AboutValues;
